import { HTTP_STATUSES } from "@miplatform/constants";
import { ISeriesResponse } from "@miplatform/types";
import { useSeries } from "@mibuildweb/hooks";

export const useAddSeriesModalViewModel = ({
  setRefresh,
  handleCloseModal,
}: {
  setRefresh: (updater: (prev: boolean) => boolean) => void;
  handleCloseModal: () => void;
}) => {
  const { isLoading, createSeries, updateSeries } = useSeries();

  const handleCreateSeries = async (data: Omit<ISeriesResponse, "id">) => {
    const response = await createSeries(data);
    if (response.status === HTTP_STATUSES.OK) {
      handleCloseModal();
      setRefresh((prev) => !prev);
    }
  };

  const handleUpdateSeries = async (data: Partial<ISeriesResponse>) => {
    const response = await updateSeries(data);
    if (response.status === HTTP_STATUSES.OK) {
      handleCloseModal();
      setRefresh((prev) => !prev);
    }
  };

  return {
    isLoading,
    handleCreateSeries,
    handleUpdateSeries,
  };
};
